var initBoardView;
$(function(){
	//help library view
	// if(!document.querySelector('.resource-search-view') && !document.getElementById('step2_product_issue')) return false; 
	if(!document.querySelector('.board-view') && !document.getElementById('modal_help_library')) return false; 

	initBoardView = function() {
		var boardView = $('.board-view');
		var boardPrint = boardView.find('.article-print');
		var boardEmail = boardView.find('.article-email');
		var boardLink = boardView.find('.article-link');
		//share 
		var boardFB = boardView.find('.share-facebook');
		var boardTW = boardView.find('.share-twitter');
		var boardPI = boardView.find('.share-pinterest');
		//question section
		var mobileTitle = $('.feedback-title .visible-xs');
		var questionSection = boardView.find('.question-section');
		var questionSectionForm = boardView.find('#articleForm');
		var questionSectionAnswer0 = questionSection.find('input[name="answer_00"]');
		var questionSectionAnswerYn = questionSection.find('input[name="answer_0000"]');
		var questionSectionStar = questionSection.find('.star-rates');
		var questionSectionStars = questionSectionStar.find('a');
		var questionSectionStarHide = boardView.find('.star-rate-hide');
		var questionSectionStarRadio = questionSection.find('input[type="radio"]');
		var questionSectionTextArea = questionSection.find('.text-area textarea');
		var questionSectionTextChar = questionSection.find('.char-current');
		var questionOtherSectionTextArea = questionSectionStarHide.find('.other-text-area textarea');//LGETW-59 20201110 add
		var questionOtherSectionTextChar = questionSectionStarHide.find('.char-other-current');//LGETW-59 20201110 add
		var questionSectionTextSubmit = questionSection.find('.submit .btn');
		var shareModal = $('#modal_resource_search_copylink');
		var submitModal = $('#modal_resource_search_success');
		var submitCheck = document.getElementById('articleForm');
		/* LGECI-538 : 20211124 add */
		var totalUse = $('#subCategorySelect_hl_pc');
		var superCateTabs = $('#superCategorySelect_hl_pc').find('[role="tab"]');
		var subCatePanel = totalUse.find('[role="tabpanel"]');
		var subCateBtn = totalUse.find('button');
		var el = document.getElementById('resourceSearchForm');
		/* LGECI-538 : 20211124 add */

		/* LGEJP-91 : 20201029 add */
		var questionSectionStarList = questionSection.find('.star-rates-list');
		/*// LGEJP-91 : 20201029 add */


		function checkUserStatus(){
			var form = $('.board-view').find('#articleForm');
			//check browser
			var isie=(/msie/i).test(navigator.userAgent); //ie
			var isie6=(/msie 6/i).test(navigator.userAgent); //ie 6
			var isie7=(/msie 7/i).test(navigator.userAgent); //ie 7
			var isie8=(/msie 8/i).test(navigator.userAgent); //ie 8
			var isie9=(/msie 9/i).test(navigator.userAgent); //ie 9
			var isfirefox=(/firefox/i).test(navigator.userAgent); //firefox
			var isapple=(/applewebkit/i).test(navigator.userAgent); //safari,chrome
			var isopera=(/opera/i).test(navigator.userAgent); //opera
			var isios=(/(ipod|iphone|ipad)/i).test(navigator.userAgent);//ios
			var isipad=(/(ipad)/i).test(navigator.userAgent);//ipad
			var isandroid=(/android/i).test(navigator.userAgent);//android

			if(isie7 || isie8 || isie9){
				isie6=false;
			}
			if(isie9){
				isie=false;
			}

			var device;
			if( /*isapple || */ isios || isandroid){
				device = "Mobile";
			}else if (isipad){
				device = "Tablet";
			}else{
				device = "Pc";
			}

			//check browser
			var a = navigator.userAgent.toLowerCase();
			var b,v;
			if(a.indexOf("safari/") > -1) {
				b = "safari";
				var s = a.indexOf("version/");
				var l = a.indexOf(" ", s);
				v = a.substring(s+8, l);
			}
			if(a.indexOf("chrome/") > -1) {
				b = "chrome";
				var ver = /[ \/]([\w.]+)/.exec(a)||[];
				v = ver[1];
			}
			if(a.indexOf("firefox/") > -1) {
				b = "firefox";
				var ver = /(?:.*? rv:([\w.]+)|)/.exec(a)||[];
				v = ver[1];
			}
			if(a.indexOf("opera/") > -1) {
				b = "opera";
				var ver = /(?:.*version|)[ \/]([\w.]+)/.exec(a)||[];
				v = ver[1];
			}
			if((a.indexOf("msie") > -1) || (a.indexOf(".net") > -1)) {
				b = "ie";
				var ver = /(?:.*? rv:([\w.]+))?/.exec(a)||[];
				if(ver[1])
					v = ver[1];
				else{
					var s = a.indexOf("msie");
					var l = a.indexOf(".", s);
					v = a.substring(s+4, l);
				}
			}

			form.find('[name=device]').val(device);
			form.find('[name=browser]').val(b);
			form.find('[name=version]').val(v);
		}
		// Set Device Info
		checkUserStatus();
		
		var screentest = function(e) {
			if (!e.matches) {  
				if (mobileTitle.hasClass('collapsed'))
				{
					mobileTitle.trigger('click');
				}
			}
		};
		mql.maxSm.addListener(screentest);
		screentest(mql.maxSm); 
		//LGECI-686
		localeCode = $('html').data('countrycode');
		if(localeCode == 'ca_en' || localeCode == 'ca_fr'){
		boardView.find('.minlegth-message').hide();
		boardView.find('.min-char-count').hide();
		}

		// LGECS-204 start
		questionSectionAnswerYn.click(function(e){
			boardView.find('.caution-q0').hide();
			questionSectionAnswer0.val(e.currentTarget.value);
			/* LGECI-473 Start */
			if(!!$(this).parents('.question-section').find('.option-guide-text').length){
				if($(this).val() == 'No') {
					$(this).parents('.question-section').find('.option-guide-text').show();
					if(localeCode == 'ca_en' || localeCode == 'ca_fr'){
					$('.min-char-count').show();
					$('.char-count').hide();
					}
				}else{
					$(this).parents('.question-section').find('.option-guide-text').hide();
					if(localeCode == 'ca_en' || localeCode == 'ca_fr'){
					$('.char-count').show();
					$('.min-char-count').hide();
					}
				}
			}
			
			/* LGECI-473 End */
		});
		// LGECS-204 end

		questionSectionStar.find('a').click(function(e){
			e.preventDefault();
			var index = $(this).index()+1;
			questionSectionForm.find('input[name="answer_01"]').attr('value',index);
			//questionSectionStar.next().hide();
			boardView.find('.caution-q1').hide();
			questionSectionStars.removeClass('on');
			for (var i=0; i<=index-1; i++ )
			{
				questionSectionStars.eq(i).addClass('on');
			}
			if (index <= 2)
			{
				questionSectionStarHide.removeClass('star-rate-hide').addClass('star-rate-show');
			} else {
				questionSectionStarHide.removeClass('star-rate-show').addClass('star-rate-hide');
				questionSectionForm.find('input[name="answer_0101"]').prop( "checked", false );
			}
		});

		/* LGEJP-91 : 20201029 add */
		questionSectionStarList.find('input[type=radio]').on('click',function(){
			//questionSectionStarList.siblings('.caution').hide();
			if($(this).val() <= 2){
				questionSectionStarHide.removeClass('star-rate-hide').addClass('star-rate-show');
			}else{
				questionSectionStarHide.removeClass('star-rate-show').addClass('star-rate-hide');
				questionSectionForm.find('input[name="answer_0101"]').prop( "checked", false );
			}
		});
		/*// LGEJP-91 : 20201029 add */
		questionSection.find("input[name='answer_0101']").click(function(e){
			//boardView.find('.star-rate-show .caution').hide();
			boardView.find('.caution-q1-1').hide();
			//LGETW-59 20201110 woosang.song add
			// LGECS-204 : 전국가 변경되서 주석 처리 start
//			if ($('input[name=otherCommentsUse]').val() == 'Y' && $('input[id=option7]').not(':checked')) {	
//				boardView.find('.error-msg').hide();
//			}
			// LGECS-204 : 전국가 변경되서 주석 처리 end
			//LGETW-59 20201110 woosang.song add
		});

		mobileTitle.on('click',function(e){
			e.preventDefault();
		});
		
		// LGECS-204 start
		questionSectionTextArea.on("change",function(e){
			if( questionSectionTextArea.val().length > 0){
				boardView.find('.caution-q2').hide();
			}
		});
		// LGECS-204 end
		
		questionSectionTextSubmit.on('click',function(e){
			e.preventDefault();
			/* LGEJP-91 : 20201029 modify */			
			// LGECS-204 : 전국가 변경되서 주석 처리 start
			/* LGEJP-287 : 20210510 modify */
			if($('input[name=starRatesListYN]').val() == 'Y'){
				if( questionSectionAnswer0.val() == ""){
					boardView.find('.caution-q0').show();
					return false;
				}
				if(!$('input[name=answer_01]').is(':checked')){
					questionSectionStarList.siblings('.caution').show();
					questionSectionStarList.find('input[type=radio]').eq(0).focus();
					return false;
				}else if ( questionSectionForm.find('input[name="answer_01"]:checked').val() <= 2){
					if(boardView.find('.star-rate-show').find('input[type="radio"]:checked').val()==undefined){
						boardView.find('.star-rate-show').find('input[type=radio]').eq(0).focus();
						boardView.find('.star-rate-show .caution').show();
						return false;
					} 
				}
				if( $('#q2_answer').val().length == 0){ //LGECS-249
					boardView.find('.caution-q2').show();
					return false;
				}
			}else{
				// LGECS-204 start
				if( questionSectionAnswer0.val() == ""){
					boardView.find('.caution-q0').show();
					return false;
				}
			
				if (questionSectionForm.find('input[name="answer_01"]').val() == 0)
				{
					//questionSectionStar.next().show();
					boardView.find('.caution-q1').show();
					questionSectionStars.eq(0).focus();
					return false;
				} else if ( questionSectionForm.find('input[name="answer_01"]').val() <= 2)
				{
					if(questionSection.find("input[name='answer_0101']:checked").val()==undefined){
						questionSectionStars.last().focus();
						//boardView.find('.star-rate-show .caution').show();
						boardView.find('.caution-q1-1').show();
						return false;
					} 
					
				}
				//LGECI-686
				if(localeCode == 'ca_en' || localeCode == 'ca_fr'){
				if(questionSectionAnswer0.val() == 'No'){
					if($('#q2_answer').val().length < 40){
						boardView.find('.minlegth-message').show();
						boardView.find('.minlegth-message').focus();
						return false;
						}	
				 }
				}
				
				if( $('#q2_answer').val().length == 0){ //LGECS-249
					boardView.find('.caution-q2').show();
					return false;
				}
				// LGECS-204 end
			}
			/*// LGEJP-287 : 20210510 modify */
			// LGECS-204 : 전국가 변경되서 주석 처리 end
			/*// LGEJP-91 : 20201029 modify */
			//LGETW-59 20201110 woosang.song add
			// LGECS-204 : 전국가 변경되서 주석 처리 start
//			if ($('input[name=otherCommentsUse]').val() == 'Y' && $('input[id=option7]').is(':checked')) {
//				var comment = $.trim($("textarea#q1_answer").val());
//				if (comment.length == 0) {
//					boardView.find('.error-msg').show();
//					return false;
//				}
//			}
			// LGECS-204 : 전국가 변경되서 주석 처리 end
			//LGETW-59 20201110 woosang.song add
			questionSectionForm.submit();
			// location.reload(true);
		});
		
		/* LGECI-538 : 20211124 add */
		if($(totalUse).length > 0){
			var superCategoryIdTotal = $('#superCategoryIdTotal').val(),
			categoryIdTotal =  $('#categoryIdTotal').val(),
			subInitPanel = 0,
			countryCode = $('html').data('countrycode'),
			expander = $(el).find('.expander button'),
			topic = $(el).find('.topic-selector'),
			selectors = $(el).find('select'),
			superCategoryId = document.getElementById('superCategorySelect_hl'),
			categoryId = document.getElementById('subCategorySelect_hl');
			
			$(superCategoryId).drawAjaxOptions({
				setTarget: categoryId
			});
			
			if(null != superCategoryIdTotal && undefined != superCategoryIdTotal && "" != superCategoryIdTotal){
				for(var a = 0 ; a < superCateTabs.length ; a++){
				    if($(superCateTabs[a]).val() == superCategoryIdTotal){
				    	superCateTabs.removeClass('active').attr('aria-selected','false');
				        $(superCateTabs[a]).addClass('active').attr('aria-selected','true');
				        subInitPanel = a;
				    }
				}
			}
			if(null != categoryIdTotal && undefined != categoryIdTotal && "" != categoryIdTotal){
				subCatePanel.removeClass('active');
				subCateBtn.removeClass('active');
				$(subCatePanel[subInitPanel]).addClass('active');
				for(var a = 0 ; a < subCateBtn.length ; a++){
				    if($(subCateBtn[a]).val() == categoryIdTotal){
				        $(subCateBtn[a]).addClass('active');
				    }
				}
			}
			superCateTabs.on('click',function(){
				var isAct = $(this).hasClass('active');
				if(!isAct) {
					var target = '#' + $(this).attr('aria-controls');
					superCateTabs.removeClass('active').attr('aria-selected','false');
					$(this).addClass('active').attr('aria-selected','true');
					subCatePanel.removeClass('active');
					$(target).addClass('active').focus();
				}
			});
			subCateBtn.on('click',function(){
				var isAct = $(this).hasClass('active');
				if(!isAct) {
					subCateBtn.removeClass('active');
					$(this).addClass('active');
					$('#superCategoryIdTotal').val($('#superCategorySelect_hl_pc').find('[role="tab"].active').val());
					$('#categoryIdTotal').val($(this).val());
					/*LGECI-668 start */
					var pageName = $("[name='pageName']").val();
					var formUrl = '/support/help-library';
					if(typeof pageName !== 'undefined'){
						formUrl = $("[name='url']").val();
					}
					window.location.href = "/"+countryCode+""+formUrl+"?superCategoryIdTotal="+$('#superCategoryIdTotal').val()+"&categoryIdTotal="+$('#categoryIdTotal').val();
					/*LGECI-668 end */
				}
			});
			
			expander.on({
				click: function(){
					if(!$(el).hasClass('expanded')) {
						$(el).addClass('expanded');
						// auto focus;
						$(el).find('.chosen-container input').eq(0).focus();
					}else {
						$(el).removeClass('expanded');
					}
				}
			});
			$(superCategoryId).on({
				'change.base': function(){
					$(topic).removeClass('active');
					categoryId.value='';
//					$('#superCategoryIdTotal').val(this.value);
					selectors.trigger('chosen:updated');
				}
			});
			$(categoryId).on({
				'change.base': function(){
					$(topic).addClass('active');
					/*LGECI-668 start */
					var pageName = $("[name='pageName']").val();
					var formUrl = '/support/help-library';
					if(typeof pageName !== 'undefined'){
						formUrl = $("[name='url']").val();
					}
//					window.location.href = "/"+countryCode+"/"+"support/help-library?superCategoryIdTotal="+$('#superCategoryIdTotal').val()+"&categoryIdTotal="+this.value;
					window.location.href = "/"+countryCode+""+formUrl+"?superCategoryIdTotal="+$('#superCategorySelect_hl').val()+"&categoryIdTotal="+$(this).val();
					/*LGECI-668 end */
				}
			});
		};
		/* LGECI-538 : 20211124 add */

		var clickSubmit = false; //LGECS-249
		if($(submitCheck).length>0) {
			submitCheck.onsubmit = function(e){
				e.preventDefault();
				/* LGECS-249 Start */
				$('body').trigger('ajaxLoadBefore');
				if(clickSubmit) {
					$('body').trigger('ajaxLoadEnd');
					return false; 
				}
				clickSubmit = true;				 
				/* LGECS-249 End */
				adobeTrackEvent('article-feedback', {page_event : {article_feedback_submit : true}});
				var url = submitCheck.getAttribute('data-url'),
					param = xssfilter($(submitCheck).serialize());
					ajax.call(url, param, 'json', function(data){
						if(data.flag=="N" && data.error.type=="downtime") {
							$('#modal_downtime').modal();
							$('#modal_downtime').find('.start-time').text(data.error.startTime);
							$('#modal_downtime').find('.end-time').text(data.error.endTime);
						} else if(data.result != true) {
							$('#feedbackError').modal();
						} else {
							$(submitCheck).closest('.feedback-form').next('.feedback-completion').find('.thanks-feedback').addClass('active');
							$(submitCheck).closest('.feedback-form').remove();
						}
						/* LGECS-249 Start */
						$('body').trigger('ajaxLoadEnd'); 
						clickSubmit = false; 
						/* LGECS-249 End */
					});
				// return false;
			};
		}

		// submitModal.find('.btn').on('click',function(){
		// 	location.reload(true);
		// });

		$(function(){
			// common.js
			checkTextLength(questionOtherSectionTextArea, questionOtherSectionTextChar);//LGETW-59 20201110 add
			checkTextLength(questionSectionTextArea, questionSectionTextChar);
		});

		//LGETW-59 20201110 radio check when textarea is selected
		// LGECS-204 : 전국가 변경되서 주석 처리 start
//		$('#q1_answer').on('focus', function(e) {
//			$('#option7').prop('checked', true);
//		});
		// LGECS-204 : 전국가 변경되서 주석 처리 end

		// Brightcove Iframe Add
		if(!document.querySelector('.video-box')){
			//console.log('not video-box');
			return false;
		} else {
			//console.log('have video-box');
		}
		var article = boardView.find('.article-content');
		var videoBox = boardView.find('.video-box').hide();
		var videoTextBox = boardView.find('.video-text-box').hide();
		var videoID = videoBox.data('video-id');
		var videoAccount = videoBox.data('account');
		var videoPlayer = videoBox.data('player');
		var videoTitle = videoBox.data('title');
		var html = '<iframe src="https://players.brightcove.net/'+ videoAccount +'/'+ videoPlayer +'_default/index.html?videoId='+ videoID +'" title="'+ videoTitle +'" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>';

		// 20203025 START 김우람 || 쿠키상관없이 brightcove 영상 허용
		videoBox.show();
		videoTextBox.show();	
		videoBox.html(html);
		/*
		if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
			//console.log('######################cookie ON');
			videoBox.show();
			videoTextBox.show();	
			videoBox.html(html);
		} else {		
			//console.log('######################cookie OFF');
			videoBox.remove();
			videoTextBox.remove();	
			ePrivacyCookies.view('load', 'small', article);
		}
		*/

	};

	if(document.querySelector('.board-view')) {
		initBoardView();
	}
});